/*
 * Nail Pen — changement de teinte INSTANTANÉ et fluide (zéro rechargement, zéro requête).
 *
 * Toutes les données de chaque teinte (url, titre, variante, ses 5 images) sont déjà embarquées
 * dans la page (attributs data-* sur chaque pastille, rendus côté serveur). Au clic, on échange
 * seulement les <img> de la galerie (par leur src, sur place), le titre et la variante, avec un
 * fondu. Aucune requête réseau → instantané. On ne vide jamais aucun conteneur → impossible de
 * « faire disparaître » la fiche. Les pastilles restent de vrais <a href> : sans JS, navigation
 * normale (dégradation propre).
 */
(function () {
  var root = document.querySelector('.shop-product-section');
  if (!root || root.dataset.shadeSwapBound === '1') return;
  root.dataset.shadeSwapBound = '1';

  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  function parseMedia(a) {
    try { return JSON.parse(a.getAttribute('data-media') || '[]'); } catch (e) { return []; }
  }

  // Préchauffe la 1re image d'une teinte (au survol) → fondu instantané au clic.
  function warm(a) {
    parseMedia(a).slice(0, 3).forEach(function (m) {
      if (!m || !m.main) return;
      try { var im = new Image(); if (m.srcset) im.srcset = m.srcset; im.src = m.main; } catch (e) {}
    });
  }

  function setVariant(vid) {
    if (!vid) return;
    // tous les <input name="id"> de la page (achat unité + barre sticky) pointent vers la teinte
    document.querySelectorAll('input[name="id"]').forEach(function (inp) { inp.value = vid; });
  }

  function applyShade(a) {
    var media = parseMedia(a);
    if (!media.length) { window.location.href = a.getAttribute('href'); return; } // sécurité

    var fadeEl = document.querySelector('.shop-image-container') || document.querySelector('.shop-product-carousel');
    if (fadeEl) { fadeEl.style.transition = 'opacity .16s ease'; fadeEl.style.opacity = '0.25'; }

    // Images principales (indexées 0..4, structure identique pour toutes les teintes).
    // On préserve l'image actuellement active (pas de reset → aucun désync avec le carrousel mobile).
    document.querySelectorAll('.shop-image-zoom-wrapper').forEach(function (wrap, i) {
      var m = media[i];
      var img = wrap.querySelector('img.shop-main-image') || wrap.querySelector('img');
      if (m && img) {
        img.src = m.main;
        if (m.srcset) { img.srcset = m.srcset; img.setAttribute('data-srcset', m.srcset); }
        img.setAttribute('data-src', m.main);
        if (m.zoom) img.setAttribute('data-zoom-src', m.zoom);
        if (m.alt != null) img.alt = m.alt;
        if (m.mediaId != null) { img.setAttribute('data-media-id', m.mediaId); wrap.setAttribute('data-media-id', m.mediaId); }
      }
    });

    // Miniatures.
    document.querySelectorAll('#thumbnail-container .shop-thumbnail').forEach(function (th, i) {
      var m = media[i];
      var img = th.querySelector('img');
      if (m && img) { img.src = m.thumb; if (m.alt != null) img.alt = m.alt; if (m.mediaId != null) img.setAttribute('data-media-id', m.mediaId); }
      if (m && m.mediaId != null) th.setAttribute('data-media-id', m.mediaId);
    });

    // Titre + libellé "COULEUR : X".
    var title = a.getAttribute('data-title');
    if (title) {
      var tEl = document.querySelector('.shop-product-title');
      // Titre personnalise (page bundle) : il nomme l'offre, pas une teinte -> on n'y touche pas.
      if (tEl && !tEl.hasAttribute('data-title-locked')) tEl.textContent = title;
      var cur = document.querySelector('.np-shades__current');
      if (cur) cur.textContent = title.replace(/\s*(nail|lip)\s*pen\s*$/i, '').trim();
    }

    // Pastille sélectionnée.
    root.querySelectorAll('.np-shade').forEach(function (el) { el.classList.remove('is-selected'); el.removeAttribute('aria-current'); });
    a.classList.add('is-selected');
    a.setAttribute('aria-current', 'true');

    // Variante (achat à l'unité + sticky).
    setVariant(a.getAttribute('data-variant'));

    // Fondu retour.
    requestAnimationFrame(function () {
      if (fadeEl) fadeEl.style.opacity = '1';
    });

    root.dispatchEvent(new CustomEvent('shade:swapped', { bubbles: true }));
  }

  // Prefetch image au survol / focus / toucher.
  function onHint(e) {
    var a = e.target && e.target.closest && e.target.closest('.np-shade[data-media]');
    if (a) warm(a);
  }
  root.addEventListener('pointerover', onHint);
  root.addEventListener('touchstart', onHint, { passive: true });
  root.addEventListener('focusin', onHint);

  // Clic → échange instantané (jamais de navigation, sauf clic modificateur / nouvel onglet).
  root.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.np-shade[data-media]');
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return; // laisse ouvrir un onglet
    e.preventDefault();
    if (a.classList.contains('is-selected')) return; // déjà la teinte affichée
    applyShade(a);
    if (!DESIGN) {
      var url = a.getAttribute('data-url') || a.getAttribute('href');
      try { history.pushState({ npShade: true, url: url }, '', url); } catch (err) {}
    }
  });

  // Retour / avance navigateur : ré-applique la teinte correspondant à l'URL.
  if (!DESIGN) {
    try { history.replaceState({ npShade: true, url: location.pathname }, '', location.href); } catch (e) {}
    window.addEventListener('popstate', function (e) {
      if (!(e.state && e.state.npShade)) { return; } // entrée cross-document : le navigateur gère
      var path = location.pathname;
      var match = null;
      root.querySelectorAll('.np-shade[data-url]').forEach(function (x) {
        var u = x.getAttribute('data-url');
        if (!match && (u === path || u === location.href || (x.getAttribute('href') === path))) match = x;
      });
      if (match) applyShade(match);
      else window.location.reload();
    });
  }

  // Préchauffe (2026-09-17, sw-perf). Avant : TOUTES les images de TOUTES les teintes en idle,
  // soit 22 × 8 images en 2x ≈ 14 Mo par fiche, en concurrence avec l'image principale
  // (LCP mesuré à 26 s sur mobile). Maintenant :
  //  - mobile (pas de survol) : rien en global ; le clic charge la teinte à la demande, avec le fondu ;
  //  - desktop : la 1re image de chaque teinte, après le chargement complet de la page, en idle ;
  //  - le survol d'une pastille (warm) reste, et couvre les 3 premières images de la teinte ;
  //  - jamais si l'utilisateur a demandé l'économie de données ou est en 2G.
  function preloadAll() {
    var c = navigator.connection || {};
    if (c.saveData || /2g/.test(c.effectiveType || '')) return;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
    root.querySelectorAll('.np-shade[data-media]').forEach(function (a) {
      var m = parseMedia(a)[0];
      if (!m || !m.main) return;
      try { var im = new Image(); if (m.srcset) im.srcset = m.srcset; im.src = m.main; } catch (e) {}
    });
  }
  function schedulePreload() {
    if ('requestIdleCallback' in window) requestIdleCallback(preloadAll, { timeout: 6000 });
    else setTimeout(preloadAll, 3000);
  }
  if (document.readyState === 'complete') schedulePreload();
  else window.addEventListener('load', schedulePreload, { once: true });
})();
